<template>
  <div class="lessonware">
    <div class="content-wrapper">
      <div class="content">
        <div class="list-wrapper">
          <div class="list" @click="newShow=true">
            <div class="icon-wrapper">
              <img src="./add.png" alt="add" width="25" height="25">
              <p class="new-ware">{{$t('m.cou_ware_addware')}}</p>
            </div>
          </div>
          <div class="list" v-for="(item,index) in lessonWareList">
            <div class="img-wrapper">
              <img :src="computeUrl(item.faceimg)" alt="img" width="284px" height="189">
              <div class="img-mask">
                <div class="two-icon-wrapper">
                  <span class="preview-icon" @click="previewWare(item)"></span>
                  <span class="edit-icon" @click="editWare(item)"></span>
                  <span class="preview" @click="previewWare(item)">{{$t('m.cou_ware_preview')}}</span>
                  <span class="edit" @click="editWare(item)">{{$t('m.cou_ware_edit')}}</span>
                </div>
              </div>
            </div>
            <div class="description">
              <div class="top">
                <h3 class="title">{{decodeURIComponent(item.coursewarename)}}</h3>
                <p class="time">{{$t('m.cou_ware_createtime')}}{{item.createtime_time}}</p>
              </div>
              <div class="bottom">
                <!--<div class="preview"-->
                <!--@click="previewWare(item)"-->
                <!--@mouseover="showText('preview',$event)"-->
                <!--@mouseout="hideText"></div>-->
                <div class="right">
                  <div class="copy"
                       @click="openCopy(item.sceneid,item.coursewarename)"
                       @mouseover="showText('copy',$event)"
                       @mouseout="hideText"></div>
                  <div class="share"
                       @click="previewWare(item)"
                       @mouseover="showText('share',$event)"
                       @mouseout="hideText"></div>
                  <div class="change"
                       @click="showChangeWare(item)"
                       @mouseover="showText('change',$event)"
                       @mouseout="hideText"></div>
                  <div class="delete"
                       @click="openDelete(item.sceneid)"
                       @mouseover="showText('delete',$event)"
                       @mouseout="hideText"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <template v-if="!isEmpty(lessonWareList)">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page.sync="currentPage"
            :page-size="7"
            @current-change="handleCurrentChange"
            :total="totoalPage">
          </el-pagination>
        </template>
      </div>
    </div>
    <top-nav :list="topList"></top-nav>
    <!--<above-nav></above-nav>-->
    <div class="lessonpop-mask" v-if="newWareShow">
      <div class="lessonpop">
        <h2 class="title">{{$t('m.cou_ware_makecourseware')}}</h2>
        <p class="row">
          <span class="left">{{$t('m.cou_ware_title')}}</span>
          <input type="text"
                 class="input-name"
                 v-model="warename"
                 maxlength="10">
        </p>
        <div class="cover-row">
          <span class="left">{{$t('m.cou_ware_cover')}}</span>
          <span class="right">
            <span class="img-wrapper">
              <img class="img" :src="imgurl" alt="cover" width="150" height="100">
            </span>
            <div class="upload-button-wrapper">
              <vue-core-image-upload
                class="upload-button"
                crop="local"
                :text="$t('m.select_img')"
                :cropBtn="{ok:'确定','cancel':'取消'}"
                cropRatio="3:2"
                @imageuploaded="imageuploaded"
                :max-file-size="5242880"
                :url="imgUpUrl">
                </vue-core-image-upload>
              <span class="hint">{{$t('m.suggest2')}}</span>
            </div>
          </span>
        </div>
        <div class="introduce-row">
          <span class="left">{{$t('m.cou_ware_introduce')}}</span>
          <textarea name="introduce"
                    class="introduce"
                    maxlength="200"
                    v-model="introduce"></textarea>
        </div>
        <div class="operate-btn-wrapper">
          <button class="btn cancel" @click="newWareShow=false">{{$t('m.cancel')}}</button>
          <button class="btn confirm" @click="createWare">{{$t('m.confirm')}}</button>
        </div>
      </div>
    </div>
    <div class="newpop-mask" v-if="newShow">
      <div class="newpop">
        <h2 class="new-title">{{$t('m.cou_ware_addware')}}</h2>
        <img class='close'
             @click="newShow=false;"
             src="./close.png"
             alt="close"
             width="24"
             height="24">
        <div class="block btn1" @click="showAddWare">
          <img class='img' src="./btn1.png" alt="add" width="30" height="30">
          <span class="text">{{$t('m.cou_ware_btn1')}}</span>
        </div>
        <div class="block btn2">
          <img class='img' src="./btn2.png" alt="add" width="30" height="30">
          <span class="text">选择文件上传</span>
          <input class="input-file"
                 type="file"
                 accept=".pdf,.ppt,.pptx,.doc,.docx"
                 @change="upFile">
        </div>
        <p class="newpop-hint">*课件上传之后如果显示格式不对，请把文件另存为pptx或者pdf格式后重新上传</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  import topNav from 'components/topnav/TopNav';
  import VueCoreImageUpload from 'vue-core-image-upload';
  import aboveNav from 'components/abovenav/AboveNav'
  export default{
    data(){
      return {
        id: (() => loadLocal('id', false))(),
        schoolNow: (() => loadLocal('schoolNow', false))(),
        lessoninfo: (() => loadLocal('lessoninfo', false))(),
        imgprefix: (() => loadLocal('imgprefix', false))(),
        topList: [
          {
            name: 'm.cou_top_bjgl',
            to: '/console/lesson/class',

          },
          {
            name: 'm.cou_top_kjgl',
            to: '/console/lesson/ware',
          },
//          {
//            name: 'm.cou_top_kcb',
//            to: '/console/lesson/schedule',
//          },
//          {
//            name: 'm.cou_top_kcyhq',
//            to: '/console/lesson/coupon'
//          },
//          {
//            name: '班级预约',
//            to: '/console/lesson/appoint',
//          },
//          {
//            name: '课程评价',
//            to: '/console/lesson/rate',
//          },
        ],
        loading:null,
        //------------------添加课件--------------------------//
        newShow: false,
        fileName:'',
        //---------------------新建课程-----------------------//
        newWareShow: false,
        warename: '',
        imgUpUrl: '',              //该url是组件‘vue-core-image-upload’上传的url地址（带sessionid）
        imgurl: require('./../cover.png'),
        upurl: '',                //不包含imgprefix,上传的图片url
        introduce: '',
        wareDisplay: {
          title: '新建课件',
          isCreate: true,
        },
        coursewareid: '',        //表示修改的课件id
        //-----------------课件列表---------------------//
        lessonWareList: [],
        currentPage: 1,
        totoalPage: 0,
      }
    },
    methods: {
      isEmpty(obj){
        for (let i in obj) {
          return !1;
        }
        return !0;
      },
      showAddWare(){
        this.newShow=false;
        this.wareDisplay.title = '新建课件';
        this.wareDisplay.isCreate = true;
        this.warename = '';
        this.imgurl = require('./../cover.png');
        this.upurl = '';
        this.introduce = '';
        this.newWareShow = true;
      },
      showChangeWare(item){
        this.wareDisplay.title = '修改课件';
        this.wareDisplay.isCreate = false;
        this.imgurl = require('./../cover.png');
        this.upurl = '';
        this.warename = decodeURIComponent(item.coursewarename);
        this.coursewareid = item.sceneid;
        if (item.faceimg !== '') {
          this.imgurl = this.imgprefix + item.faceimg;
          this.upurl = item.faceimg;
        }
        this.introduce = decodeURIComponent(item.introduce);
        this.newWareShow = true;
      },
      //上传文件（ppt、pdf）
      upFile(e){
        this.loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        let input = e.target;
        // 通过DOM取文件数据
        let file = input.files[0];
        this.fileName=file.name;
        let xhr = new XMLHttpRequest();
        //initiate request
        let url = '/indexapp.php?c=Upload&a=UploadFileNew&id=' + this.id;
        xhr.open('post', url, true);
        //set headers
        xhr.setRequestHeader('X-File-Name', encodeURI(file.name));
        xhr.addEventListener('load', this.uploadComplete, false);
        //send the file
        xhr.send(file);
        this.newShow=false;
      },
      uploadComplete: function (evt) {
        let response = evt.target.responseText;
        let jsonobj = JSON.parse(response);
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'ImportCourseWareFromImages',
            id: this.id,
            rid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            coursewarename: this.fileName,
            uploadfilename: jsonobj.image
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.QueryCourseWares(1);
            this.currentPage = 1;
            this.loading.close();
          }else{
            this.loading.close();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //新建课件
      createWare(){
        if (this.upurl == '' || this.lessonname == '') {
          return;
        }

        let params = {
          c: 'CourseWare',
          id: this.id,
          rid: this.schoolNow.rid,
          lessonid: this.lessoninfo.id,
          coursewarename: this.warename,
          faceimg: this.upurl,
        };
        //如果是新建课件
        if (this.wareDisplay.isCreate) {
          params.a = 'AddCourseWare';
        } else {
          params.a = 'UpdateCourseWare';
          params.coursewareid = this.coursewareid;
        }
        if (this.introduce !== '') {
          params.introduce = this.introduce;
        }
        //接口：指定用户新建课程
        this.$http({
          url: '/indexapp.php',
          method: 'get',
          params: params,
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '添加课件成功',
              type: 'success'
            });
            this.newWareShow = false;
            this.QueryCourseWares(1);
            this.currentPage = 1;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        })
      },
      //VueCoreImageUpload上传后调用的方法
      imageuploaded(response) {
        if (response.code === 200) {
          this.imgurl = response.imgprefix + response.image;
          this.upurl = response.image;
        }
      },
      computeUrl(url){
        if (url === '') {
          return require('./cover.png');
        } else {
          return this.imgprefix + url;
        }
      },
      //改变页码时
      handleCurrentChange(val) {
        this.QueryCourseWares(val);
      },
      //编辑课件
      editWare(item){
        window.open(`${this.GLOBAL.editUrl}indexapp.php#/scene/create/${item.sceneid}?pageId=1&sid=${this.id}`)
      },
      //预览课件和分享课件(预览和分享是同一个功能)
      previewWare(item){
        window.open(`${this.GLOBAL.playUrl}v/${item.code}`);
      },
      //获取课程的课件列表
      QueryCourseWares(page){
        this.lessonWareList = [];
        //接口：查询课程的课件列表
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'QueryCourseWares',
            id: this.id,
            queryrid: this.schoolNow.rid,
            lessonid: this.lessoninfo.id,
            pageno: page,
            pagesize: 7,
            count: 1
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.lessonWareList = response.list;
            this.totoalPage = response.recordcount;
            this.$forceUpdate();
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //鼠标悬浮在课程列表上的icon显示的文字
      showText: function (string, ev) {
        let lang=loadLocal('language',false);
        if (string === 'copy') {
          ev.target.innerText = '复制';
        } else if (string === 'share') {
          ev.target.innerText = '分享';
        } else if (string === 'change') {
          ev.target.innerText = '修改';
        } else if (string === 'delete') {
          ev.target.innerText = '删除';
        } else if (string === 'preview') {
          ev.target.innerText = '预览';
        }
        this.$forceUpdate();
      },
      //移去鼠标，隐藏文字
      hideText(ev){
        ev.target.innerText = '';
        this.$forceUpdate();
      },
      //打开复制
      openCopy(coursewareid, coursewarename){
        let lang=loadLocal('language',false);
        let text,hint,confirm,cancel;
        text='确认复制吗该课件吗？';
        hint='提示';
        confirm='确认';
        cancel='取消';
        this.$confirm(text, hint, {
          confirmButtonText: confirm,
          cancelButtonText: cancel,
        }).then(() => {
          this.copyCourseWare(coursewareid, coursewarename);
        }).catch(() => {
        });
      },
      //复制课件
      copyCourseWare(coursewareid, coursewarename){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'CopyCourseWare',
            id: this.id,
            tolessonid: this.lessoninfo.id,
            rid: this.schoolNow.rid,
            coursewareid: coursewareid,
            coursewarename: coursewarename
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
          }
          if (response.code === 200) {
            this.$message({
              message: '复制课件成功',
              type: 'success'
            });
            this.QueryCourseWares(1);
            this.currentPage = 1;
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      },
      //打开删除
      openDelete(coursewareid){
        let lang=loadLocal('language',false);
        let text,hint,confirm,cancel;
        text='确定删除该课件吗？';
        hint='提示';
        confirm='确认';
        cancel='取消';
        this.$confirm(text, hint, {
          confirmButtonText: confirm,
          cancelButtonText: cancel,
        }).then(() => {
          this.deleteCourseWare(coursewareid);
        }).catch(() => {
        });
      },
      //删除课件
      deleteCourseWare(coursewareid){
        this.$http({
          url: '/indexapp.php',
          method: 'GET',
          params: {
            c: 'CourseWare',
            a: 'DeleteCourseWare',
            id: this.id,
            rid: this.schoolNow.rid,
            coursewareid: coursewareid
          }
        }).then((response) => {
          response = response.data;
          if (response.code === 111) {
            this.$router.push({path:'/log',query:{url:this.$getUrl.getUrl()}});
            return;
          }
          if (response.code === 200) {
            this.$message({
              message: '删除课件成功',
              type: 'success'
            });
            this.QueryCourseWares(1);
            this.currentPage = 1;
          }else{
            this.$message({
              message: response.msg,
              type: 'warning'
            });
          }
        }).catch((err) => {
          this.$alert('未获取到数据，请重新加载页面', '提示', {
            confirmButtonText: '刷新',
            callback: action => {
              window.location.reload();
            }
          });
        });
      }
    },
    created(){
      //获取课件列表
      this.QueryCourseWares(1);
      //裁切图片上传的地址
      this.imgUpUrl = `${this.GLOBAL.uploadUrl}indexapp.php?c=Upload&a=UploadFileVue&id=` + this.id;
    },
    components: {
      topNav,
      VueCoreImageUpload,
      aboveNav
    },
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .lessonware
    position fixed
    left: 160px
    top: 91px
    right: 0
    bottom: 0
    background #f2f2f2
    overflow auto
    z-index: 10
    .content-wrapper
      padding: 20px 0 20px
      min-width: 1206px
      font-size: 0
      overflow auto
      .content
        margin-left: 20px
        padding-bottom: 20px
        width: 1166px
        .list
          display: inline-block
          margin: 0 10px 10px 0
          height: 309px
          width: 284px
          background: #fff
          vertical-align top
          overflow: hidden
          cursor: pointer
          &:hover
            box-shadow: 0 0 15px 2px #e4e4e4
          &:hover .description
            transform: translateY(-40px)
          &:hover .img-wrapper .img-mask
            display block
          &:nth-child(4n)
            margin-right: 0
          .icon-wrapper
            width: 100px
            height: 70px
            margin: 120px auto
            text-align: center
            .new-ware
              margin-top: 10px
              font-size: 16px
              color: #999999

          .img-wrapper
            width: 284px
            height: 189px
            position relative
            .img-mask
              display none
              position absolute
              top: 0
              right: 0
              bottom: 0
              left: 0
              background rgba(0, 0, 0, 0.5)
              .two-icon-wrapper
                display: inline-block
                margin: 40px 0 0 72px
                width: 140px
                .preview-icon
                  display: inline-block
                  width: 50px
                  height: 50px
                  border-radius 50px
                  overflow hidden
                  background url(./pre-icon.png) no-repeat center / 50px 50px
                .edit-icon
                  display: inline-block
                  margin-left: 40px
                  width: 50px
                  height: 50px
                  background #fff
                  background url(./edit-icon.png) no-repeat center / 50px 50px
                .preview, .edit
                  margin-top: 10px
                  display: inline-block
                  width: 50px
                  font-size: 14px
                  color: #fff
                  text-align center
                .edit
                  margin-left: 40px
          .description
            position: relative
            height: 160px
            padding: 0 10px
            transition-duration: 300ms
            background: #ffffff
            .top
              padding: 35px 0 0 0
              height: 120px
              text-align: center
              box-sizing: border-box
              .title
                font-size: 16px
                color: #000000
                font-weight: bold
                line-height: 20px
              .time
                margin-top: 15px
                font-size: 12px
                color: #555
            .bottom
              height: 40px
              font-size: 12px
              color: #ffffff
              /*.preview*/
              /*margin: 5px 0 0 0*/
              /*display: inline-block*/
              /*width: 28px*/
              /*height: 28px*/
              /*line-height: 28px*/
              /*border: 1px solid #e4e4e4*/
              /*border-radius: 4px*/
              /*cursor: pointer*/
              /*transition-duration: 200ms*/
              /*background: url('./preview.png') no-repeat center left 8px*/
              /*background-size: 14px 14px*/
              /*&:hover*/
              /*width: 60px*/
              /*height: 30px*/
              /*line-height: 30px*/
              /*text-indent: 28px*/
              /*background: #3399ff url('./previewd.png') no-repeat center left 8px*/
              /*background-size: 14px 14px*/
              /*border: none*/

              .right
                float: right
                .copy, .share, .change, .delete
                  vertical-align: top
                  margin: 5px 5px 0 0
                  display: inline-block
                  width: 28px
                  height: 28px
                  line-height: 28px
                  border: 1px solid #e4e4e4
                  border-radius: 4px
                  cursor: pointer
                  transition-duration: 200ms
                  &:hover
                    width: 65px
                    height: 30px
                    line-height: 30px
                    text-indent: 28px
                    border: none
                .copy
                  background: url('./copy.png') no-repeat center left 8px
                  background-size: 14px 14px
                  &:hover
                    background: #3399ff url('./copyd.png') no-repeat center left 8px
                    background-size: 14px 14px
                .share
                  background: url('./share.png') no-repeat center left 8px
                  background-size: 14px 14px
                  &:hover
                    background: #3399ff url('./shared.png') no-repeat center left 8px
                    background-size: 14px 14px
                .change
                  background: url('./change.png') no-repeat center left 8px
                  background-size: 14px 14px
                  &:hover
                    background: #00cc66 url('./changed.png') no-repeat center left 8px
                    background-size: 14px 14px
                .delete
                  background: url('./delete.png') no-repeat center left 8px
                  background-size: 14px 14px
                  &:hover
                    background: #ff6666 url('./deleted.png') no-repeat center left 8px
                    background-size: 14px 14px
    .lessonpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .lessonpop
        margin: auto
        width: 565px
        padding: 30px 60px 40px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        .title
          padding: 0 0 45px
          line-height: 40px
          font-size: 24px
          color: #000
          font-weight: bold
        .row
          margin-bottom: 10px
          height: 35px
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
          .input-name
            width: 350px
            height: 35px
            font-size: 15px
            color: #000
            padding-left: 6px
            border: 1px solid #d7d7d7
            border-radius: 4px
            box-sizing: border-box
            &::-webkit-input-placeholder
              color: #ccc
        .cover-row
          margin-bottom: 12px
          height: 140px
          .left
            display: inline-block
            margin-right: 10px
            width: 75px
            height: 100%
            line-height: 100px
            font-size: 15px
            color: #888
            vertical-align: top
          .right
            display: inline-block
            .img
              vertical-align: top
            .upload-button-wrapper
              height: 30px
              margin-top: 10px
              padding-left: 10px
              .upload-button
                display: inline-block
                margin-right: 10px
                height: 30px
                line-height: 30px
                width: 90px
                text-align: center
                background: #f2f2f2
                color: #666
                font-size: 13px
                border: 1px solid #d7d7d7
                border-radius: 4px
                box-sizing border-box
                vertical-align: top
                cursor: pointer
              .hint
                display: inline-block
                padding:0 10px
                line-height: 28px
                text-align: center
                font-size: 12px
                color: #999999
                border-radius: 4px
                border: 1px solid #ffb76e
                background: #fff9e7

        .introduce-row
          .left
            display: inline-block
            margin-right: 10px
            line-height: 35px
            width: 75px
            font-size: 15px
            color: #888
            vertical-align top
          .introduce
            padding: 10px
            width: 350px
            height: 150px
            font-size: 15px
            color: #333
            box-sizing border-box
            border-radius 4px
            border: 1px solid #d7d7d7
            line-height: 20px
            resize: none
        .operate-btn-wrapper
          margin: 40px auto 0
          width: 225px
          .btn
            width: 80px
            height: 34px
            line-height: 34px
            font-size: 16px
            color: #ffffff
            border-radius 4px
          .cancel
            margin-right: 65px
            background #ccc
          .confirm
            background #3399ff

    .newpop-mask
      position: fixed
      top: 0
      bottom: 0
      left: 0
      right: 0
      display: flex
      background: rgba(0, 0, 0, 0.3)
      z-index: 1000
      overflow: auto
      .newpop
        margin: auto
        padding: 30px 60px 30px
        border-radius: 4px
        background: #ffffff
        font-size: 0
        box-sizing border-box
        position relative
        .new-title
          font-size: 24px
          color: #000000
          font-weight: bold
          height: 34px
          line-height: 34px
        .close
          position absolute
          top: 30px
          right: 20px
          cursor: pointer
        .block
          margin-top: 20px
          padding: 0 35px
          height: 80px
          line-height: 80px
          border-radius: 4px
          cursor: pointer
          .img
            position relative
            top: 10px
          .text
            display inline-block
            width: 150px
            height: 80px
            line-height: 80px
            text-align: center
            font-size: 16px
            color: #ffffff
        .btn1
          margin-top: 40px
          background #3399ff
        .btn2
          background: #33cc33
          position relative
          .input-file
            position: absolute
            left: 0
            top: 0
            right:0
            bottom:0
            width: 100%;
            height: 100%;
            padding: 0
            margin: 0
            opacity: 0
            cursor:pointer
        .newpop-hint{
          margin-top:16px;
          line-height:14px;
          font-size:12px;
          color:#666;
          width: 250px;
        }
</style>



// WEBPACK FOOTER //
// src/page/lesson/lessonware/LessonWare.vue